import { render, staticRenderFns } from "./ModalAiTest.vue?vue&type=template&id=c212e506&scoped=true&"
import script from "./ModalAiTest.vue?vue&type=script&lang=js&"
export * from "./ModalAiTest.vue?vue&type=script&lang=js&"
import style0 from "./ModalAiTest.vue?vue&type=style&index=0&id=c212e506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c212e506",
  null
  
)

export default component.exports